import React, { useEffect, useState } from 'react';
import { useForm, ValidationError } from '@formspree/react';
import { Layout } from '@msanvarov/core-components';
import { en } from '@msanvarov/i18n';
import { Alert, Form } from 'reactstrap';
import LocationCard from '../../../libs/core-components/src/lib/globe';
import { Turnstile } from '@marsidev/react-turnstile';
import { useTheme } from 'next-themes';

const ContactPage = () => {
  const [state, handleSubmit] = useForm('xwkgadjr');
  const [displayBanner, setDisplayBanner] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState<string | null>(null);
  const { theme, setTheme } = useTheme();

  const handleFormSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!recaptchaToken) {
      return; 
    }

    const result = await handleSubmit(event);
   
  };

  useEffect(() => {
    if (state.submitting) {
      setDisplayBanner(false);
    }
    if (state.succeeded) {
      setDisplayBanner(true);
    }
  }, [state]);

  const handleCaptchaChange = (token: string | null) => {
    if (token) {
      setRecaptchaToken(token);
    } else {
      console.error('Captcha verification failed.');
      setRecaptchaToken(null);
    }
  };

  const toggleTheme = () => {
    setTheme(theme === 'dark' ? 'light' : 'dark');
  };

  return (
    <Layout wrapperClass="main-aboutpage" title="Contact">
      <section className="contact-area">
        <div className="container">
          <div className="gx-row d-flex justify-content-between gap-24">
            <div className="contact-infos">
              <h3 data-aos="fade-up">{en.contact.contact.heading}</h3>
              <ul className="contact-details">
                <li className="d-flex align-items-center" data-aos="zoom-in">
                  <div className="icon-box shadow-box">
                    <i className={en.contact.contact.mail.icon} />
                  </div>
                  <div className="right">
                    <span>{en.contact.contact.mail.heading}</span>
                    {en.contact.contact.mail.links.map((item, index) => (
                      <h4 key={index}>
                        <a href={`mailto:${item}`}>{item}</a>
                      </h4>
                    ))}
                  </div>
                </li>
                <li className="d-flex align-items-center" data-aos="zoom-in">
                  <div className="icon-box shadow-box">
                    <a
                      href="https://cal.com/abhishekpanthee/30min"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <i className={en.contact.contact.phone.icon} />
                    </a>
                  </div>
                  <div className="right">
                    <span>{en.contact.contact.phone.heading}</span>
                    {en.contact.contact.phone.links.map((item, index) => (
                      <h4 key={index}>
                        <a href={item.href}>{item.text}</a>
                      </h4>
                    ))}
                  </div>
                </li>
                <li className="d-flex align-items-center" data-aos="zoom-in">
                  <div className="icon-box shadow-box">
                    <i className={en.contact.contact.location.icon} />
                  </div>
                  <div className="right">
                    <span>{en.contact.contact.location.heading}</span>
                    <h4>{en.contact.contact.location.location}</h4>
                  </div>
                </li>
              </ul>
              <h3 data-aos="fade-up">{en.contact.profiles.heading}</h3>
              <ul className="social-links d-flex align-center" data-aos="zoom-in">
                <li>
                  <a
                    className="shadow-box"
                    href="https://github.com/abhishekpanthee"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    <i className="iconoir-github" />
                  </a>
                </li>
                <li>
                  <a
                    className="shadow-box"
                    href="https://www.linkedin.com/in/abhishekpanthee"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    <i className="iconoir-linkedin" />
                  </a>
                </li>
                <li>
                  <a
                    className="shadow-box"
                    href="https://www.instagram.com/abhishek.panthee"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    <i className="iconoir-instagram" />
                  </a>
                </li>
              </ul>
            </div>
            <div data-aos="zoom-in" className="contact-form">
              <div className="shadow-box">
                <img src="/assets/bg1.png" alt="BG" className="bg-img" />
                <img src="/assets/icons/icon3.png" alt="Icon" />
                <h1 dangerouslySetInnerHTML={{ __html: en.contact.form.heading }}></h1>


                <Form onSubmit={handleFormSubmit}>
                  {displayBanner && (
                    <Alert
                      className="messenger-box-contact__msg"
                      role="alert"
                      color="success"
                      isOpen={displayBanner}
                      toggle={() => setDisplayBanner(false)}
                    >
                      {en.contact.form.onCompletion}
                    </Alert>
                  )}

                  <div className="input-group">
                    <input
                      type="text"
                      name="name"
                      id="name"
                      required
                      placeholder="Name *"
                    />
                    <ValidationError prefix="Name" field="name" errors={state.errors} />
                  </div>
                  <div className="input-group">
                    <input
                      id="email"
                      type="email"
                      name="email"
                      required
                      placeholder="Email *"
                    />
                    <ValidationError prefix="Email" field="email" errors={state.errors} />
                  </div>
                  <div className="input-group">
                    <input
                      type="text"
                      name="topic"
                      id="topic"
                      required
                      placeholder="Topic *"
                    />
                    <ValidationError prefix="topic" field="topic" errors={state.errors} />
                  </div>
                  <div className="input-group">
                    <textarea
                      name="message"
                      id="message"
                      required
                      placeholder="Message *"
                    />
                    <ValidationError prefix="Message" field="message" errors={state.errors} />
                  </div>

                  <div className="w-full max-w-xl mx-auto flex justify-center items-center ml-4">
  <h2 className="text-center ml-4 ">  <Turnstile
                      siteKey="0x4AAAAAABiY0maNAdweuHyj"
                      onSuccess={handleCaptchaChange}
                      onError={() => handleCaptchaChange(null)}
                      onExpire={() => handleCaptchaChange(null)}
                      options={{ theme: theme as 'light' | 'dark' }}
                    /></h2>
                  
                  </div>

                  <div className="input-group">
                    <button
                      className="theme-btn submit-btn"
                      type="submit"
                      disabled={state.submitting || !recaptchaToken} 
                    >
                      {recaptchaToken ? en.contact.form.button.text : 'Complete CAPTCHA to Submit'}
                    </button>
                  </div>
                </Form>
              </div>
              <LocationCard />
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default ContactPage;

